module.exports = __webpack_public_path__ + "img/collegeview.88857601.png";